module.exports = __webpack_public_path__ + "static/media/4.9ecd73cf.png";